
// import React, { useState, useEffect } from "react";
// import { Form, InputNumber, Grid, Table, Card } from "antd";
// import moment from "moment";

// const { useBreakpoint } = Grid;

// const EmiPayment = ({
//   onFooterChange,
//   salesVoucherNumber,
//   dueAmount,
//   createdDate,
//   paidAmount,
//   conversionRate,
//   emis = [],          // 🔹 edit data
//   emiMonths,          // 🔹 edit data
//   emiDayWeek,         // 🔹 edit data
//   emiAmount,          // 🔹 edit data
// }) => {
//   const [form] = Form.useForm();
//   const screens = useBreakpoint();
//   const isMobile = !screens.md || !screens.xl;

//   const [emiMonth, setEmiMonths] = useState(emiMonths || 0);
//   const [dayWeek, setDayWeek] = useState(emiDayWeek || 0);
//   const [amount, setAmount] = useState(emiAmount || 0);
//   const [data, setData] = useState([]);

//   /* ================= EMI TABLE ================= */
//   const columns = [
//     { title: "EMI NO", dataIndex: "emiNo" },
//     { title: "FROM DATE", dataIndex: "fromDate" },
//     { title: "LAST PAY DATE", dataIndex: "lastPayDate" },
//     {
//       title: "AMOUNT",
//       dataIndex: "amount",
//       render: (val) => {
//         const amt = Number(val);
//         const final = conversionRate ? amt * conversionRate : amt;
//         return final?.toFixed(2);
//       },
//     },
//   ];

//   /* ========== EDIT MODE: PREFILL EMI DATA ========== */
//   useEffect(() => {
//     if (emis && emis.length > 0) {
//       setData(emis);
//       onFooterChange(emis, "emis");

//       form.setFieldsValue({
//         emiMonths: emiMonths,
//         dayWeek: emiDayWeek,
//         amount: emiAmount,
//       });
//     }
//   }, [emis]);

//   /* ========== CREATE MODE: AUTO GENERATE EMI ========== */
//   useEffect(() => {
//     if (!emiMonth || emis.length > 0) return;

//     const emiCount = Number(emiMonth);
//     const currMonthStart = moment(createdDate).startOf("month");

//     const rows = Array.from({ length: emiCount }, (_, i) => ({
//       emiNo: `${i + 1}-${salesVoucherNumber}`,
//       fromDate: currMonthStart.clone().add(i + 1, "month").format("YYYY-MM-DD"),
//       lastPayDate: currMonthStart
//         .clone()
//         .add(i + 1, "month")
//         .add(9, "days")
//         .format("YYYY-MM-DD"),
//       amount: Number((dueAmount / emiCount).toFixed(2)),
//     }));

//     setData(rows);
//     onFooterChange(rows, "emis");
//   }, [emiMonth, dueAmount]);

//   /* ========== AUTO DAY/WEEK CALC ========== */
//   useEffect(() => {
//     if (!amount || !dueAmount) return;
//     const dw = dueAmount / amount;
//     setDayWeek(Math.round(dw));
//   }, [amount, dueAmount]);

//   return (
//     <Card title="EMI Payment" style={{ marginBottom: 5 }}>
//       <Form
//         form={form}
//         layout={!isMobile ? "inline" : "vertical"}
//         style={{ width: "100%", gap: 10 }}
//       >
//         {/* EMI MONTHS */}
//         <Form.Item
//           name="emiMonths"
//           rules={[{ required: true, message: "Enter EMI months!" }]}
//           style={{ flexGrow: 1 }}
//         >
//           <InputNumber
//             min={1}
//             max={99}
//             placeholder="EMI Months"
//             style={{ width: "100%" }}
//             value={emiMonth}
//             onChange={(value) => {
//               setEmiMonths(value);
//               onFooterChange(value, "emiMonths");
//             }}
//           />
//         </Form.Item>

//         {/* DAY / WEEK */}
//         <Form.Item name="dayWeek" style={{ flexGrow: 1 }}>
//           <InputNumber
//             min={1}
//             max={99}
//             placeholder="Day / Week"
//             style={{ width: "100%" }}
//             value={dayWeek}
//             onChange={(value) => {
//               setDayWeek(value);
//               onFooterChange(value, "emiDayWeek");

//               if (dueAmount && value) {
//                 const calc = Number((dueAmount / value).toFixed(2));
//                 setAmount(calc);
//                 form.setFieldsValue({ amount: calc });
//                 onFooterChange(calc, "emiAmount");
//               }
//             }}
//           />
//         </Form.Item>

//         {/* AMOUNT */}
//         <Form.Item
//           name="amount"
//           rules={[{ required: true, message: "Enter amount!" }]}
//           style={{ flexGrow: 1 }}
//         >
//           <InputNumber
//             placeholder="Amount"
//             style={{ width: "100%" }}
//             value={amount}
//             formatter={(val) =>
//               val
//                 ? Number(
//                   conversionRate ? val * conversionRate : val
//                 ).toFixed(2)
//                 : "0.00"
//             }
//             onChange={(value) => {
//               setAmount(value);
//               onFooterChange(value, "emiAmount");
//             }}
//           />
//         </Form.Item>
//       </Form>

//       <Table
//         columns={columns}
//         dataSource={data}
//         pagination={false}
//         rowKey="emiNo"
//         style={{ marginTop: 10 }}
//       />
//     </Card>
//   );
// };

// export default EmiPayment;


// EmiPayment.jsx
// EmiPayment.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Form, InputNumber, Grid, Table, Card, Tag, Alert, Button, Row, Col } from "antd";
import moment from "moment";

const { useBreakpoint } = Grid;

const EmiPayment = ({
  onFooterChange,
  salesVoucherNumber,
  dueAmount = 0,
  createdDate,
  paidAmount = 0,
  conversionRate = 1,
  emis = [],
  emiMonths = 0,
  emiDayWeek = "0",
  emiAmount = 0,
  isEditMode = false,
}) => {
  const [form] = Form.useForm();
  const screens = useBreakpoint();
  const isMobile = !screens.md || !screens.xl;

  const [emiMonth, setEmiMonths] = useState(emiMonths);
  const [dayWeek, setDayWeek] = useState(emiDayWeek);
  const [amount, setAmount] = useState(emiAmount);
  const [data, setData] = useState(emis || []);
  const [mode] = useState(isEditMode ? "edit" : "create");

  // Track previous values to detect changes
  const prevEmiMonthRef = useRef(emiMonths);
  const prevDueAmountRef = useRef(dueAmount);

  /* ================= Generate EMI Data ================= */
  const generateEmiData = useCallback((months, amountPerMonth, forceRegenerate = false) => {
  
    if (months <= 0 || amountPerMonth <= 0) {
     setData([]);
      onFooterChange([], "emis");
      return;
    }

   const startDate = createdDate
    ? moment(createdDate).add(1, "month")
    : moment().add(1, "month");
    const rows = Array.from({ length: months }, (_, i) => ({
      emiNo: `${i + 1}-${salesVoucherNumber || "NEW"}`,
      fromDate: startDate.clone().add(i, "month").format("YYYY-MM-DD"),
      lastPayDate: startDate
        .clone()
        .add(i, "month")
        .add(9, "days")
        .format("YYYY-MM-DD"),
      amount: amountPerMonth,
      key: `${salesVoucherNumber || "NEW"}-${i + 1}`,
    }));

    setData(rows);
    onFooterChange(rows, "emis");
  }, [createdDate, salesVoucherNumber, onFooterChange]);

  /* ================= Calculate Amount Per Month ================= */
  const calculateAmountPerMonth = useCallback((dueAmt, months) => {
    if (!dueAmt || !months || months <= 0) return 0;
    return Number((dueAmt / months).toFixed(2));
  }, []);

  /* ================= Calculate Day/Week ================= */
  const calculateDayWeek = useCallback((dueAmt, emiAmt) => {
    if (!dueAmt || !emiAmt || emiAmt <= 0) return "0";
    const dw = Math.round(dueAmt / emiAmt);
    return dw.toString();
  }, []);

  /* ========== INITIAL LOAD & SYNC ========== */
  useEffect(() => {
 
    // If edit mode with existing data
    if (mode === "edit" && emis && emis.length > 0) {
     const emiData = emis.map((emi, idx) => ({
        ...emi,
        key: emi.emiNo || `${idx + 1}-${salesVoucherNumber || "EDIT"}`
      }));

      setData(emiData);

      // Calculate values from existing data
      const calculatedMonths = emiData.length;
      const calculatedAmount = emiData[0]?.amount || 0;
      const calculatedDayWeek = calculateDayWeek(dueAmount, calculatedAmount);

      // Update state
      setEmiMonths(calculatedMonths);
      setAmount(calculatedAmount);
      setDayWeek(calculatedDayWeek);

      // Update form
      form.setFieldsValue({
        emiMonths: calculatedMonths,
        amount: calculatedAmount,
        dayWeek: calculatedDayWeek,
      });

      // Notify parent
      onFooterChange(emiData, "emis");
      onFooterChange(calculatedMonths, "emiMonths");
      onFooterChange(calculatedAmount, "emiAmount");
      onFooterChange(calculatedDayWeek, "emiDayWeek");
    }
  }, [mode]); // Run once on mount

  /* ========== REGENERATE WHEN EMI MONTHS OR DUE AMOUNT CHANGES ========== */
  useEffect(() => {


    // Skip if in edit mode with existing data (unless months changed from 0)
    if (mode === "edit" && data.length > 0 && emiMonth === data.length) {
     prevEmiMonthRef.current = emiMonth;
      prevDueAmountRef.current = dueAmount;
      return;
    }

    // If EMI months changed or due amount changed
    const emiMonthChanged = emiMonth !== prevEmiMonthRef.current;
    const dueAmountChanged = dueAmount !== prevDueAmountRef.current;

    if ((emiMonthChanged || dueAmountChanged) && emiMonth > 0 && dueAmount > 0) {
   
      const amountPerMonth = calculateAmountPerMonth(dueAmount, emiMonth);
      const calculatedDayWeek = calculateDayWeek(dueAmount, amountPerMonth);

      // Update state
      setAmount(amountPerMonth);
      setDayWeek(calculatedDayWeek);

      // Update form
      form.setFieldsValue({
        amount: amountPerMonth,
        dayWeek: calculatedDayWeek,
      });

      // Generate EMI data
      generateEmiData(emiMonth, amountPerMonth);

      // Notify parent
      onFooterChange(amountPerMonth, "emiAmount");
      onFooterChange(calculatedDayWeek, "emiDayWeek");
    }

    // Update refs
    prevEmiMonthRef.current = emiMonth;
    prevDueAmountRef.current = dueAmount;
  }, [emiMonth, dueAmount, mode, data.length]);

  /* ========== Handle EMI Month Change ========== */
  const handleEmiMonthChange = (value) => {
    const newEmiMonth = value || 0;
  
    setEmiMonths(newEmiMonth);
    onFooterChange(newEmiMonth, "emiMonths");

    // Clear everything if set to 0
    if (newEmiMonth <= 0) {
    setData([]);
      setAmount(0);
      setDayWeek("0");

      form.setFieldsValue({
        amount: 0,
        dayWeek: "0"
      });

      onFooterChange([], "emis");
      onFooterChange(0, "emiAmount");
      onFooterChange("0", "emiDayWeek");
      return;
    }

    // For create mode or edit mode without data
    if (mode === "create" || (mode === "edit" && data.length === 0)) {
      if (dueAmount > 0) {
        const newAmount = calculateAmountPerMonth(dueAmount, newEmiMonth);
        const newDayWeek = calculateDayWeek(dueAmount, newAmount);

  
        setAmount(newAmount);
        setDayWeek(newDayWeek);

        form.setFieldsValue({
          amount: newAmount,
          dayWeek: newDayWeek,
        });

        generateEmiData(newEmiMonth, newAmount);

        onFooterChange(newAmount, "emiAmount");
        onFooterChange(newDayWeek, "emiDayWeek");
      } else {
    // Just update the months, wait for due amount
        setData([]);
      }
    }

    // For edit mode with existing data - warn user
    if (mode === "edit" && data.length > 0 && newEmiMonth !== data.length) {
      console.warn("Changing EMI months in edit mode will regenerate schedule");
      // We'll regenerate in the useEffect above
    }
  };

  /* ========== Handle Day/Week Change ========== */
  const handleDayWeekChange = (value) => {
    const newDayWeek = value || "0";
   
    setDayWeek(newDayWeek);
    onFooterChange(newDayWeek, "emiDayWeek");

    if (dueAmount && value && value > 0) {
      const newAmount = calculateAmountPerMonth(dueAmount, value);
      const calculatedMonths = Math.round(dueAmount / newAmount);

 
      setAmount(newAmount);
      form.setFieldValue("amount", newAmount);
      onFooterChange(newAmount, "emiAmount");

      // Update EMI months if different
      if (calculatedMonths !== emiMonth) {
        setEmiMonths(calculatedMonths);
        form.setFieldValue("emiMonths", calculatedMonths);
        onFooterChange(calculatedMonths, "emiMonths");
        generateEmiData(calculatedMonths, newAmount);
      } else {
        // Just regenerate with same months
        generateEmiData(emiMonth, newAmount);
      }
    }
  };

  /* ========== Handle Amount Change ========== */
  const handleAmountChange = (value) => {
    const newAmount = value || 0;
 
    setAmount(newAmount);
    onFooterChange(newAmount, "emiAmount");

    if (dueAmount && value && value > 0) {
      const newDayWeek = calculateDayWeek(dueAmount, value);
      const calculatedMonths = Math.round(dueAmount / value);

    
      setDayWeek(newDayWeek);
      form.setFieldValue("dayWeek", newDayWeek);
      onFooterChange(newDayWeek, "emiDayWeek");

      // Update EMI months if different
      if (calculatedMonths !== emiMonth) {
        setEmiMonths(calculatedMonths);
        form.setFieldValue("emiMonths", calculatedMonths);
        onFooterChange(calculatedMonths, "emiMonths");
        generateEmiData(calculatedMonths, newAmount);
      } else {
        // Just regenerate with same months
        generateEmiData(emiMonth, newAmount);
      }
    }
  };

  /* ========== Manual Regenerate Button ========== */
  const handleRegenerate = () => {
  
    if (emiMonth > 0 && dueAmount > 0) {
      const amountPerMonth = calculateAmountPerMonth(dueAmount, emiMonth);
      const calculatedDayWeek = calculateDayWeek(dueAmount, amountPerMonth);

      setAmount(amountPerMonth);
      setDayWeek(calculatedDayWeek);

      form.setFieldsValue({
        amount: amountPerMonth,
        dayWeek: calculatedDayWeek,
      });

      generateEmiData(emiMonth, amountPerMonth);

      onFooterChange(amountPerMonth, "emiAmount");
      onFooterChange(calculatedDayWeek, "emiDayWeek");
    }
  };

  /* ========== Clear EMI Data ========== */
  const handleClearEmi = () => {

    setEmiMonths(0);
    setDayWeek("0");
    setAmount(0);
    setData([]);

    form.setFieldsValue({
      emiMonths: 0,
      dayWeek: "0",
      amount: 0,
    });

    onFooterChange([], "emis");
    onFooterChange(0, "emiMonths");
    onFooterChange("0", "emiDayWeek");
    onFooterChange(0, "emiAmount");
  };

  /* ================= EMI Table Columns ================= */
  const columns = [
    {
      title: "EMI NO",
      dataIndex: "emiNo",
      width: 100,
      render: (text) => <Tag color="blue">{text}</Tag>
    },
    {
      title: "FROM DATE",
      dataIndex: "fromDate",
      width: 120,
      render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
    },
    {
      title: "LAST PAY DATE",
      dataIndex: "lastPayDate",
      width: 120,
      render: (date) => date ? moment(date).format("DD/MM/YYYY") : "N/A"
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      width: 100,
      render: (val) => {
        const amt = Number(val) || 0;
        const final = conversionRate ? amt * conversionRate : amt;
        return <strong>{final?.toFixed(2)}</strong>;
      },
    },
  ];

  // Check if we need to show regenerate button
  const shouldShowRegenerate = emiMonth > 0 && dueAmount > 0 &&
    (data.length === 0 || data.length !== emiMonth || data[0]?.amount !== amount);

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>EMI Payment</span>
          {/* <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Tag color={mode === "edit" ? "orange" : "green"}>
              {mode === "edit" ? "Edit Mode" : "Create Mode"}
            </Tag>
            {emiMonth > 0 && (
              <Tag color="blue">{emiMonth} Month{emiMonth > 1 ? 's' : ''}</Tag>
            )}
          </div> */}
        </div>
      }
      style={{ marginBottom: 5 }}
      extra={
        <div style={{ display: 'flex', gap: 5 }}>
          {/* {shouldShowRegenerate && (
            <Button size="small" onClick={handleRegenerate}>
              Regenerate
            </Button>
          )}
          {emiMonth > 0 && (
            <a onClick={handleClearEmi} style={{ color: '#ff4d4f' }}>
              Clear EMI
            </a>
          )} */}
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
      >
        {/* First Row: EMI Months and Day/Week */}
        <Row gutter={16}>
          {/* EMI MONTHS - Left side */}
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="emiMonths"
              label="EMI Months"
              rules={[{ required: true, message: "Enter EMI months!" }]}
            >
              <InputNumber
                min={0}
                max={99}
                placeholder="EMI Months"
                style={{ width: "100%" }}
                value={emiMonth}
                onChange={handleEmiMonthChange}
                onWheel={(e) => e.target.blur()}
                onBlur={() => {
                  if (emiMonth > 0 && dueAmount > 0 && data.length === 0) {
                    handleRegenerate();
                  }
                }}
              />
            </Form.Item>
          </Col>

          {/* DAY / WEEK - Right side */}
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="dayWeek"
              label="Day/Week"
            >
              <InputNumber
                min={0}
                max={99}
                placeholder="Day / Week"
                style={{ width: "100%" }}
                value={dayWeek}
                onChange={handleDayWeekChange}
                onWheel={(e) => e.target.blur()}
                disabled={!emiMonth || emiMonth <= 0}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Second Row: Amount field */}
        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Form.Item
              name="amount"
              label="Amount"
              rules={[{ required: true, message: "Enter amount!" }]}
            >
              <InputNumber
                placeholder="Amount"
                style={{ width: "100%" }}
                value={amount}
                formatter={(val) =>
                  val
                    ? Number(
                      conversionRate ? val * conversionRate : val
                    ).toFixed(2)
                    : "0.00"
                }
                onChange={handleAmountChange}
                onWheel={(e) => e.target.blur()}
                disabled={!emiMonth || emiMonth <= 0}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {emiMonth > 0 && dueAmount > 0 && data.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '20px',
          color: '#faad14',
          backgroundColor: '#fff7e6',
          borderRadius: 4,
          marginTop: 10
        }}>
          <div>EMI schedule not generated.</div>
          <div>Click "Regenerate" button or change any value to generate schedule.</div>
          <Button
            type="primary"
            size="small"
            onClick={handleRegenerate}
            style={{ marginTop: 10 }}
          >
            Generate Schedule
          </Button>
        </div>
      )}

      {emiMonth > 0 && data.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 10
          }}>
            <strong>EMI Schedule ({data.length} installments)</strong>
            <span>
              Total: <strong>
                {(data.reduce((sum, item) => sum + (item.amount || 0), 0) * (conversionRate || 1)).toFixed(2)}
              </strong>
            </span>
          </div>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="key"
            size="small"
            scroll={{ x: 400 }}
          />
        </div>
      )}

      {/* {emiMonth <= 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px', 
          color: '#999',
          backgroundColor: '#f5f5f5',
          borderRadius: 4,
          marginTop: 10
        }}>
          EMI is disabled. Set EMI months greater than 0 to enable.
        </div>
      )} */}

      {/* Debug info - remove in production */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          marginTop: 10,
          padding: 10,
          backgroundColor: '#f0f0f0',
          fontSize: '12px',
          borderRadius: 4
        }}>

        </div>
      )}
    </Card>
  );
};

export default EmiPayment;